<div class="row row-fav">
  <!-- <div class="spinnerAdmin" *ngIf = "isLoader">
  <app-spinner></app-spinner>
</div> -->
<ngx-spinner
  name="upsSpinner"
  bdColor="rgba(255, 255, 255, 0.8)"
  size="medium"
  color="#321815"
  type="custom"
  [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

@if(!isLoader) {
  <div class="col-12">
    <div class="card card-body mt-1">
      <div class="row">
        <div class="col-12 text-center">
          <span class="h3"><b>Admin Functions</b></span>
          <br />
          <button
            type="button"
            class="btn btn-yellow-filled float-right btn-add-user"
            (click)="openAddModal(template)">
            <i class="fas fa-plus-square"></i> Add User
          </button>
        </div>
      </div>
      <br />
      <app-dynamictable
        [displayedColumns]="displayedColumns"
        [dataSource]="dataSource"
        (openDialog)="openDialog($event)"
        [isFromBulkUpload]="true"
        [hideFilterAndRefresh]="true">
      </app-dynamictable>
    </div>
  </div>
}
</div>

<ng-template #template>
  <form [formGroup]="adminRequestForm">
    <div class="card card-body modal-card">
      <div class="modal-header modal-header-custom">
        <h4 class="modal-title text-center modal-title-custom">
          {{isEdit ? 'Edit' : 'Add New'}} User
        </h4>
        <button
          type="button"
          class="btn btn-warning btn-lg btn-close-custom"
          aria-label="Close"
          (click)="closePopup()">
          <i class="fas fa-window-close"></i>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <div class="card card-body text-end">
        <div class="col-sm-12 font-12">
          <div class="form-group">
            <div class="form-group row">
              <label class="col-4 col-form-label">
                User ID<span class="required">*</span>
              </label>
              <div class="col-4">
                <input
                  type="text"
                  class="form-control form-control-lg"
                  formControlName="userid"
                  placeholder="User ID"
                  (blur)="onBlurCustomerID(adminRequestForm.get('userid')?.value)"
                  maxlength="200" />
                  @if (
                    adminRequestForm.controls['userid'].invalid &&
                    (adminRequestForm.controls['userid'].dirty ||
                    adminRequestForm.controls['userid'].touched)
                    ) {
                    <span
                      class="text-danger"
                      >
                      {{ formErrors.userid }}
                    </span>
                  }
                </div>
              </div>

              <div class="form-group row">
                <label class="col-4 col-form-label">
                  First Name<span class="required">*</span>
                </label>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control form-control-lg"
                    formControlName="firstname"
                    placeholder="First Name"
                    maxlength="200" />
                    @if (
                      adminRequestForm.controls['firstname'].invalid &&
                      (adminRequestForm.controls['firstname'].dirty ||
                      adminRequestForm.controls['firstname'].touched)
                      ) {
                      <span
                        class="text-danger"
                        >
                        {{ formErrors.firstname }}
                      </span>
                    }
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-4 col-form-label">Last Name</label>
                  <div class="col-4">
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      formControlName="lastname"
                      placeholder="Last Name"
                      maxlength="200" />
                      @if (
                        adminRequestForm.controls['lastname'].invalid &&
                        (adminRequestForm.controls['lastname'].dirty ||
                        adminRequestForm.controls['lastname'].touched)
                        ) {
                        <span
                          class="text-danger"
                          >
                          {{ formErrors.lastname }}
                        </span>
                      }
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-4 col-form-label">
                      Role Description<span class="required">*</span>
                    </label>
                    <div class="col-4">
                      <ng-select
                        id="roledescription"
                        formControlName="roledescription"
                        [items]="roleDetails"
                        bindLabel="roleDescription"
                        placeholder="Select Role Description"
                        appendTo="body"
                        [multiple]="true"
                        (change)="onChangeRoleDesc($event,adminRequestForm.get('userid')?.value)"
                        [(ngModel)]="selectedRoleDesc">
                        <ng-template ng-header-tmp>
                          <div>
                            <button
                              class="btn btn-link"
                              (click)="onClearAllRoleDesc()">
                              Clear All
                            </button>
                          </div>
                        </ng-template>
                      </ng-select>
                      @if (
                        adminRequestForm.controls['roledescription'].invalid &&
                        (adminRequestForm.controls['roledescription'].dirty ||
                        adminRequestForm.controls['roledescription'].touched)
                        ) {
                        <span
                          class="text-danger"
                          >
                          {{ formErrors.roledescription }}
                        </span>
                      }
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-4 col-form-label">RPF<span class="required">*</span></label>
                    <div class="col-4">
                      <ng-select
                        id="rpfName"
                        formControlName="rpfName"
                        [items]="rpfDetails"
                        bindLabel="rpfName"
                        placeholder="Select RPF"
                        appendTo="body"
                        [multiple]="true"
                        [(ngModel)]="selectedRpf"
                  [disabled]="
                    selectedRoleDesc?.length === 1 &&
                    selectedRoleDesc[0]?.roleId === 5
                  ">
                        <ng-template ng-header-tmp>
                          <div>
                            <button
                              class="btn btn-link"
                              (click)="onClearAllRpfDesc()">
                              Clear All
                            </button>
                          </div>
                        </ng-template>
                      </ng-select>
                      @if (
                        adminRequestForm.controls['rpfName'].invalid &&
                        (adminRequestForm.controls['rpfName'].dirty ||
                        adminRequestForm.controls['rpfName'].touched)
                        ) {
                        <span
                          class="text-danger"
                          >
                          {{ formErrors.rpfName }}
                        </span>
                      }
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-4 col-form-label">
                      User Email Address<span class="required">*</span>
                    </label>
                    <div class="col-4">
                      <input
                        type="text"
                        class="form-control form-control-lg"
                        formControlName="email"
                        placeholder="User Email Address"
                        maxlength="200" />
                        @if (
                          adminRequestForm.controls['email'].invalid &&
                          (adminRequestForm.controls['email'].dirty ||
                          adminRequestForm.controls['email'].touched)
                          ) {
                          <span
                            class="text-danger"
                            >
                            {{ formErrors.email }}
                          </span>
                        }
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label">Comments</label>
                      <div class="col-4">
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          formControlName="comments"
                          placeholder="Comments"
                          maxlength="100" />
                        </div>
                      </div>

                      <div class="text-center">
                        <div class="text-center">
                          <button
                            type="button"
                            class="btn btn-yellow-filled mt-4"
                            (click)="submitRequest()">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ng-template>
